export default __webpack_public_path__ + "static/media/OpenPadlock.628a78da.svg";